module.exports = __webpack_public_path__ + "593a3d53/img/question-icon.06c20c5d.svg";